"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _loader = require("../styles/loader"),
    _Icon = _interopRequireDefault(require("../../Icon"));

function Loader(a) {
  var b = a.hint,
      c = a.text,
      d = a.darkTheme;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("loader", (0, _loader.WRAPPER)({
      darkTheme: d
    }))
  }, _react["default"].createElement("div", null), _react["default"].createElement("div", {
    className: (0, _classnames["default"])("loader__content", _loader.CENTER_DIV)
  }, _react["default"].createElement(_Icon["default"], {
    name: "videocamera",
    size: 75,
    color: "monkey"
  }), _react["default"].createElement("p", {
    className: (0, _classnames["default"])("loader__content__text", (0, _loader.MAIN_TEXT)({
      darkTheme: d
    }))
  }, c)), b ? _react["default"].createElement("p", {
    className: (0, _classnames["default"])("loader__hint", (0, _loader.HINT)({
      darkTheme: d
    }))
  }, _react["default"].createElement("strong", null, "DID YOU KNOW: "), b) : _react["default"].createElement("div", null));
}

Loader.defaultProps = {
  text: "Loading your experience..."
};

var _default = (0, _react.memo)(Loader);

exports["default"] = _default;